<template>
  <v-content>
        <v-container fluid>
            <v-row class="my-2" align="center" justify="center">
                <h1 style="color: #777777" v-html="$t('titlePrefix')"></h1>
                <h1 style="color: #00F784" v-html="$t('titleMiddle')"></h1>
                <h1 style="color: #777777" v-html="$t('titleSuffix')"></h1>
            </v-row>
            <!--v-row class="my-1" align="center" justify="center">
                <h4 style="color: #777777" v-html="$t('monthly')"></h4>
                <v-switch v-model="showAnnuallyPlans" @change="switchPlans" class="ml-4" inset></v-switch>
                <h4 style="color: #777777">{{ $t('annually') }}</h4>
                <v-chip class="ml-1" color="yellow" x-small><span style="font-size: 14px;">{{ $t('saveTwoMonths') }}</span></v-chip>
            </v-row-->
            <v-row class="my-1 pt-5 mx-12" align="center" justify="center">
                <v-slider
                    v-model="periodIndex"
                    :tick-labels="periodLabels"
                    :max="2"
                    step="1"
                    thumb-color="yellow"
                    thumb-label="always"
                    thumb-size="0"
                    @change="switchPlans"
                >
                    <template v-slot:thumb-label="{ value }">
                        <v-chip v-if="value !== 0" class="mb-6" color="yellow" x-small><span style="font-size: 14px;">{{ periodDiscounts[value] }}</span></v-chip>
                    </template>
                    <!--template v-slot:tick-label="{ value }">
                        <v-chip class="ml-1" color="yellow" x-small><span style="font-size: 14px;">{{ periodLabels[value] }}</span></v-chip>
                    </template-->
                </v-slider>
            </v-row>
            <v-row class="my-0" align="center" justify="center">
                <PlanCardClub :key="'plan'+i" v-for="(plan, i) in plans" :plan="plan" :periodIndex="periodIndex" @payNow="payWithEPayco"/>
            </v-row>
            <v-row class="my-1" align="center" justify="center">
                <p class="text-center mt-4" v-html="$t('footerMessage')"></p>
            </v-row>
        </v-container>

        <!-- ePayco Checkout overlay -->
        <v-overlay :dark="false" :value="checkoutDialog">
            <Checkout :plan="planToCheckout" :clubId="this.$store.state.clubMember.club.id" @cancelPayment="cancelEPaycoPayment" @successfulPayment="successEPaycofulPayment" @errorOnPayment="errorOnEPaycoPayment"/>
        </v-overlay>
  </v-content>
</template>

<script>
import PlanCardClub from './PlanCardClub';
import PricingPlans from './pricingPlans';
import SubscriptionRepository from './../../../../repositories/subscription';
import Checkout from "./../../Checkout";

export default {
    name: "SubscriptionPlansClub",
    components: {
        PlanCardClub,
        Checkout
    },
    data() {
        return {
            plans: PricingPlans.monthlyClub,

            periodIndex: 0,

            periodLabels: [
                this.$t('monthly'),
                this.$t('semiannually'),
                this.$t('annually')
            ],

            periodDiscounts: [
                '',
                this.$t('saveOneMonth'),
                this.$t('saveTwoMonths')
            ],

            // PayPal settings
            paypalButtonSize: 'Small',
            paypalButtonShape: 'pill',

            // Payment confirmation info
            confirmationInfo: {
                titleMessage: this.$t('confirmationInfo.titleMessage'),
                bodyMessage: this.$t('confirmationInfo.bodyMessage'),
                goToMessage: this.$t('confirmationInfo.goToMessage'),
                afterConfirmationRoute: 'dashboard',
            },

            // Dialog message information
            dialog: false,
            dialogTitle: '',
            dialogMessage: '',

            // ePayco Checkout
            planToCheckout: null,
            checkoutDialog: false,
        }
    },
    created() {
        this.validateAuthenticated();
    },
    mounted() {
        window.fbq('track', 'InitiateCheckout');

        // Call paypal set up script and initialization
        const script = document.createElement("script");
        script.src = this.$store.state.paypalSubscriptionsScript;
        script.addEventListener("load", this.renderPaypalButtons);
        document.body.appendChild(script);
        
    },
    methods: {
        validateAuthenticated() {
            if(this.$store.state.token === '')
                this.$router.push('/');
        },
        switchPlans() {
            if(this.periodIndex == 0) {
                this.plans = PricingPlans.monthlyClub;
            } else if (this.periodIndex == 1){
                this.plans = PricingPlans.semiannualClub;
            } else {
                this.plans = PricingPlans.annuallyClub;
            }
        },
        renderPaypalButtons(){
            var elements = document.querySelectorAll('.paypal-button-container');
            for(let i = 0; i < elements.length; i++) {
                window.paypal.Buttons({
                    style: {
                        size: this.paypalButtonSize,
                        color: this.plans[i+1].color,
                        shape: this.paypalButtonShape,
                    },
                    createSubscription: (data, actions) => {
                        return actions.subscription.create({
                            'plan_id': this.plans[i+1].planId
                        });
                    },
                    onApprove: async (data) => {
                        let subInfo = {
                            user_id: this.$store.state.user.id,
                            subscription_id: data.subscriptionID,
                            plan_id: this.plans[i+1].planId,
                            club_id: this.$store.state.clubMember.club.id
                        };
                        SubscriptionRepository.subscriptionApproved(subInfo).then((response) => {
                            if(response.status < 400){
                                window.fbq('track', 'Purchase');
                                this.$router.push({
                                    name: 'confirmation',
                                    params: { titleMessage: this.confirmationInfo.titleMessage,
                                        bodyMessage: this.confirmationInfo.bodyMessage,
                                        goToMessage: this.confirmationInfo.goToMessage,
                                        afterConfirmationRoute: this.confirmationInfo.afterConfirmationRoute}
                                });
                            }
                        })
                    },
                    onError: () => {
                        this.dialogTitle = this.$t('somethingWentWrong_SubscriptionPlansClub');
                        this.dialogMessage = this.$t('errorTryingToConnect_SubscriptionPlansClub');
                        this.dialog = true;
                    }
                }).render(elements[i]);
            }
        },
        payWithEPayco(plan) {
            if(plan.planName !== 'Free') {
                this.planToCheckout = plan;
                this.checkoutDialog = true;
            } else {
                this.$router.back();
            }
        },
        successEPaycofulPayment() {
            this.checkoutDialog = false;
            window.fbq('track', 'Purchase');
            this.$router.push({
                name: 'confirmation',
                params: { titleMessage: this.confirmationInfo.titleMessage,
                    bodyMessage: this.confirmationInfo.bodyMessage,
                    goToMessage: this.confirmationInfo.goToMessage,
                    afterConfirmationRoute: this.confirmationInfo.afterConfirmationRoute}
            });
        },
        errorOnEPaycoPayment() {
            this.checkoutDialog = false;
            this.dialogTitle = this.$t('somethingWentWrong_SubscriptionPlansClub');
            this.dialogMessage = this.$t('errorTryingToConnect_SubscriptionPlansClub');
            this.dialog = true;
        },
        cancelEPaycoPayment() {
            this.checkoutDialog = false;
        },
    }
}
</script>

<style scoped>

</style>

